import { setResolutionAction } from 'pages/LayoutEditorPage/actions/layoutEditor';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetThemeAction, setAction } from 'redux/actions/projectConfig';
import { RootState } from 'redux/store';
import IconButton from 'shared/buttons/IconButton';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';
import OptionSelector from './OptionSelector';
import ResolutionSection, { Dimensions } from './ResolutionSection';

type WorkspaceBarProps = {
  panelOptions: any;
};

export default function WorkspaceBar(props: WorkspaceBarProps) {
  const dispatch = useDispatch();
  const { tab, themeOptions } = useSelector((state: RootState) => state.projectConfig);
  const { dataConfig } = useSelector((state: RootState) => state.projectConfig);
  const { type } = useSelector((state: RootState) => state.layoutEditorPage);
  const setResolution = (dimensions: Dimensions) => {
    dispatch(setResolutionAction(dimensions));
  };

  const updateSelectedPanel = (e: React.MouseEvent) => {
    const target = e.currentTarget;
    const newTab = target.id;
    if (newTab === 'data') setResolution({ width: null, height: null });
    dispatch(
      setAction({
        tab: newTab
      })
    );
  };

  const onRemoveTheme = () => {
    dispatch(resetThemeAction());
  };

  const goToGSheet = () => {
    const w = window.open(
      `https://docs.google.com/spreadsheets/d/${dataConfig.googleSpreadsheetKey}/edit#gid=0`,
      '_blank'
    );
    if (w) w.focus();
  };

  return (
    <div className="bg-white rounded-sm w-full flex h-16">
      <OptionSelector updateSelectedPanel={updateSelectedPanel} activePanel={tab} panelOptions={props.panelOptions} />
      {themeOptions.id && (
        <IconButton
          icon="trash"
          onClick={onRemoveTheme}
          buttonColor={ButtonColor.White}
          hoverText="Remove theme"
          className="h-8 px-2 rounded self-center hidden ev-sm:block"
        />
      )}

      {type === 'table' && dataConfig?.googleSpreadsheetKey && (
        <IconButton
          icon="link"
          onClick={goToGSheet}
          buttonColor={ButtonColor.White}
          hoverText="Edit Google sheet"
          className="h-8 px-2 rounded self-center hidden ev-sm:block"
        />
      )}

      {tab !== 'data' && <ResolutionSection setResolution={setResolution} showPreviewText={true} />}
    </div>
  );
}
